import React from 'react';

function Header (){
    return <header> <h1>Sticky Note</h1> </header>
}

export default Header